var _metadata, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdporten(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsDc: "http://purl.org/dc/elements/1.1/",
    xmlnsCc: "http://creativecommons.org/ns#",
    xmlnsRdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    height: 36,
    width: 36,
    xmlSpace: "preserve",
    id: "svg2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata8"
  }, /*#__PURE__*/React.createElement("rdfRDF", null, /*#__PURE__*/React.createElement("ccWork", {
    rdfAbout: ""
  }, /*#__PURE__*/React.createElement("dcFormat", null, "image/svg+xml"), /*#__PURE__*/React.createElement("dcType", {
    rdfResource: "http://purl.org/dc/dcmitype/StillImage"
  }), /*#__PURE__*/React.createElement("dcTitle", null))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,36.000001)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.01476192)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#d1d3cc",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "M 1829.03,82.1992 C 1829.03,33.8008 1795.21,0 1746.83,0 H 82.207 C 33.7969,0 0,33.8008 0,82.1992 V 1746.83 c 0,48.4 33.7969,82.2 82.207,82.2 H 1746.83 c 48.38,0 82.2,-33.8 82.2,-82.2 V 82.1992"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#29292c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 784.121,662.57 -226.98,332.063 0.254,-0.067 c -21.75,52.024 41.582,78.654 45.972,80.344 0.168,0.03 0.473,0.18 0.473,0.18 v 69.93 H 263.059 V 844.352 c 0.488,0 0.945,-0.141 1.445,-0.141 24.668,-1.145 36.824,-7.824 48.648,-26.051 6.243,-9.629 10.063,-20.73 10.063,-32.769 V 564.512 c 0,-34.782 -21.02,-59.153 -58.711,-60.91 -0.5,0 -0.957,-0.172 -1.445,-0.172 V 244.84 c 0,-12.02 9.976,-21.871 22.156,-21.871 H 603.84 v 70 h -0.625 c -5.902,2.269 -62.375,30.922 -32.817,86.422 l -0.054,0.039 213.758,282.879 0.117,0.113 -0.02,0.039 0.02,0.07 -0.098,0.039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#29292c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1044.94,662.57 226.96,332.063 -0.24,-0.067 c 21.74,52.024 -41.58,78.654 -45.98,80.344 -0.16,0.03 -0.47,0.18 -0.47,0.18 v 69.93 h 340.77 V 844.352 c -0.48,0 -0.94,-0.141 -1.45,-0.141 -24.64,-1.145 -36.82,-7.824 -48.62,-26.051 -6.27,-9.629 -10.08,-20.73 -10.08,-32.769 V 564.512 c 0,-34.782 21.04,-59.153 58.7,-60.91 0.51,0 0.97,-0.172 1.45,-0.172 V 244.84 c 0,-12.02 -9.99,-21.871 -22.16,-21.871 h -318.61 v 70 h 0.62 c 5.9,2.269 62.37,30.922 32.83,86.422 l 0.04,0.039 -213.74,282.879 -0.14,0.113 0.02,0.039 -0.02,0.07 0.12,0.039"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#29292c",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    d: "m 1565.98,1532.54 c 0,40.63 -32.32,73.52 -72.21,73.52 h -168.32 v -160.35 h -260.61 c -13.22,0 -20.02,6.55 -20.02,20.04 v 140.31 H 784.219 l 0.547,-140.84 c 0,-13.49 -5.821,-19.51 -19.051,-19.51 H 503.613 v 160.35 H 326.848 v -0.54 c -35.91,-4.26 -63.789,-35.29 -63.789,-72.98 V 1265.3 H 1565.98 v 267.24"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdporten);
export default __webpack_public_path__ + "static/media/idporten.666a52d973e9539331b72e74c06d3624.svg";
export { ForwardRef as ReactComponent };